<template>
  <section class="section">
    <div class="container">
      <div class="columns is-multiline">
        <div class="column is-4">
          <b-button :disabled="disabledbool" style="width: 100%" class="is-primary" @click="importModel">
            {{ $translate('catalog_view') }}
          </b-button>
        </div>
        <b-tabs position class="blocks fulllength" horizontal>
          <b-tab-item :label="$translate('tomaio') | capitalize">
            <h3 class="green subtitle">
              {{ $translate('subtitle_form_model_tomaio_order') }}
            </h3>
            <hr />
            <div class="columns">
              <div class="column is-4">
                <imageModel :mod.sync="mod" :order.sync="order" />
              </div>
              <div class="column is-8">
                <tomaio
                  ref="tomaio"
                  :mod.sync="mod"
                  :orderbool="true"
                  :module="'fits'"
                  :disabledbool="true"
                  :availablepell.sync="availablepell"
                />
              </div>
            </div>
          </b-tab-item>
          <b-tab-item :label="$translate('fodera') | capitalize">
            <h3 class="green subtitle">
              {{ $translate('subtitle_form_model_fodera_order') }}
            </h3>
            <hr />
            <div class="columns">
              <div class="column is-4">
                <imageModel :mod.sync="mod" :order.sync="order" />
              </div>
              <div class="column is-8">
                <fodera
                  ref="fodera"
                  :mod.sync="mod"
                  :orderbool="true"
                  :disabledbool.sync="mod.catalogchoose || mod.color_bool || disabledbool"
                  :availablefode.sync="availablefode"
                />
              </div>
            </div>
          </b-tab-item>
          <b-tab-item :label="$translate('allacciatura') | capitalize">
            <h3 class="green subtitle">
              {{ $translate('subtitle_form_model_allacciatura_order') }}
            </h3>
            <hr />
            <div class="columns">
              <div class="column is-4">
                <imageModel :mod.sync="mod" :order.sync="order" />
              </div>
              <div class="column is-8">
                <allacciatura
                  ref="allacciatura"
                  :mod.sync="mod"
                  :orderbool="true"
                  :disabledbool.sync="!mod.image || mod.catalogchoose || disabledbool"
                  :availableallacc.sync="availableallacc"
                  :is-simplified.sync="isSimplified"
                />
              </div>
            </div>
          </b-tab-item>
          <b-tab-item :label="$translate('suola') | capitalize">
            <h3 class="green subtitle">
              {{ $translate('subtitle_form_model_suola_order') }}
            </h3>
            <hr />
            <div class="columns">
              <div class="column is-4">
                <imageModel :mod.sync="mod" :order.sync="order" />
              </div>
              <div class="column is-8">
                <suola
                  ref="suola"
                  :order.sync="order"
                  :mod.sync="mod"
                  :orderbool="true"
                  :disabledbool.sync="!mod.image || mod.catalogchoose || disabledbool"
                  :disabledboolcolor.sync="mod.color_bool"
                  :availablesoles.sync="filteredSoles"
                  :availablebatt.sync="availablebatt"
                  :availablefogge="filteredFogge"
                  :is-simplified.sync="isSimplified"
                  @onUpdateSole="setSole"
                />
              </div>
            </div>
          </b-tab-item>
        </b-tabs>
        <b-modal :active.sync="isComponentModalActive" has-modal-card trap-focus aria-role="dialog" aria-modal>
          <div class="modal-card">
            <header class="modal-card-head">
              <p class="modal-card-title">
                {{ $translate('catalog_view') }} {{ $translate(catalogType) }}
                {{ $translate(shoeType) }}
              </p>
              <b-input v-model="filterModel" />
            </header>
            <section class="modal-card-body">
              <div class="columns is-multiline is-mobile">
                <div v-for="model in filteredModels" :key="model.id" class="column is-one-quarter">
                  <div class="card">
                    <div class="card-image">
                      <figure class="image is-4by3">
                        <img :src="model.image" alt="Placeholder image" />
                      </figure>
                    </div>
                    <div class="card-content" style="height: 96px">
                      <div class="content has-text-centered">
                        {{ model.name }}
                      </div>
                    </div>
                    <footer class="card-footer">
                      <a
                        class="card-footer-item"
                        @click="
                          tempmodel = model
                          importBasicData()
                        "
                        >{{ $translate('import') | capitalize }}</a
                      >
                    </footer>
                  </div>
                </div>
              </div>
            </section>
            <footer class="modal-card-foot">
              <button class="button" type="button" @click="isComponentModalActive = false">
                {{ $translate('close') | capitalize }}
              </button>
            </footer>
          </div>
        </b-modal>
      </div>
    </div>
  </section>
</template>

<script>
import materialTools from '../../../helpers/mixins/materialTools'
import { compareModelPosition } from '@/helpers/mixins/modelTools'
//import modelTools from '../../../helpers/mixins/modelTools'
/*import modelTailored from '@/helpers/mixins/modelTools'*/
import tomaio from '../../Mod/components/tomaio'
import fodera from '../../Orders/components/fodera-fits-orders'
import suola from '../../Orders/components/suola-orders.vue'
import allacciatura from '../../Mod/components/allacciatura-fits'
import imageModel from './ImageModel'
//import allestimento from "../../Mod/components/allestimento";

export default {
  name: 'OrderModel',
  components: {
    //allestimento: allestimento,
    allacciatura: allacciatura,
    suola: suola,
    fodera: fodera,
    tomaio: tomaio,
    imageModel: imageModel,
  },
  mixins: [materialTools],
  props: {
    mod: {
      type: Object,
      default: () => {
        return {}
      },
    },
    availablepell: {
      type: Array,
      default: () => {
        return []
      },
    },
    availablefode: {
      type: Array,
      default: () => {
        return []
      },
    },
    availablebatt: {
      type: Array,
      default: () => {
        return []
      },
    },
    availableguard: {
      type: Array,
      default: () => {
        return []
      },
    },
    availablesott: {
      type: Array,
      default: () => {
        return []
      },
    },
    availablepunt: {
      type: Array,
      default: () => {
        return []
      },
    },
    availableallacc: {
      type: Array,
      default: () => {
        return []
      },
    },
    availablesoles: {
      type: Array,
      default: () => {
        return []
      },
    },
    shoeType: {
      type: String,
      default: null,
    },
    catalogType: {
      type: String,
      default: null,
    },
    disabledbool: Boolean,
    catalogModel: {
      type: Object,
      default: () => {
        return {}
      },
    },
    isSaveDisabled: Boolean,
    order: {
      type: Object,
      default: () => {
        return {}
      },
    },
    isSimplified: Boolean,
    config: {
      type: Object,
      required: true,
      default: () => {
        return {}
      },
    },
  },

  inject: ['$validator'],
  data() {
    return {
      models: [],
      isComponentModalActive: false,
      uploadFile: null,
      uploadFileBool: false,
      tempmodel: {},
      web_catalog: [],
      filterModel: '',
      filteredSoles: [],
      filteredFogge: [],
    }
  },
  computed: {
    filteredModels() {
      return this.models
        .filter(model => {
          return model.name.includes(this.filterModel)
        })
        .sort(compareModelPosition)
    },
  },
  watch: {
    shoeType: async function() {
      if (this.shoeType != null && this.catalogType != null) {
        this.refreshCatalog()
      }
    },
    catalogType: async function() {
      if (this.shoeType != null && this.catalogType != null) {
        this.refreshCatalog()
      }
    },
  },
  methods: {
    refreshCatalog() {
      if (this.catalogModel !== undefined) {
        this.$db
          .collection(this.config.models)
          .where('catalogType', '==', this.catalogType)
          .where('shoeType', '==', this.shoeType)
          .where('draft', '==', false)
          .get()
          .then(docs => {
            this.models = []
            docs.forEach(doc => {
              let mode = doc.data()
              mode.id = doc.id
              if (this.catalogModel[mode.id]) {
                this.models.push(mode)
              }
            })
            this.$forceUpdate()
          })
      }
    },
    async updateAfterload() {
      if (this.shoeType != null && this.catalogType != null) {
        this.refreshCatalog()
      }

      this.setModelSoleData(this.mod)

      this.$refs.tomaio.updateAfterload()
      this.$refs.suola.updateAfterLoad()
    },

    importImage() {
      this.$buefy.notification.open({
        duration: 3000,
        message: this.$translate('warning_import_model'),
        type: 'is-warning',
      })

      var tempmop = this.mod
      tempmop.image = this.tempmodel.image
      this.mod.catalogchoose = false
      this.disabledbool = false
      this.$emit('update:mod', tempmop)
      this.isComponentModalActive = false
    },
    importBasicData() {
      let tempMod = this.tempmodel
      tempMod.name = this.tempmodel.name
      tempMod.id = this.tempmodel.id
      tempMod.catalogchoose = false

      this.setModelSoleData(this.tempmodel)
      this.disabledbool = false
      this.$emit('update:mod', tempMod)
      this.isComponentModalActive = false
    },
    importModel() {
      if (this.shoeType != null && this.catalogType != null) {
        this.isComponentModalActive = true
      } else {
        //this.$buefy.toast.open(`Specifica il catalogo e il tipo di calzatura`);
        this.$buefy.toast.open(this.$translate('error_catalog'))
      }
    },
    deliveryUpdated() {
      this.$forceUpdate()
    },

    setModelSoleData(model) {
      let filteredSoles = this.availablesoles.filter(sole => {
        return model.soles.includes(sole.id)
      })
      if (filteredSoles) {
        filteredSoles = filteredSoles.filter(sole => {
          return sole.shapes.some(shape => shape.type === this.order.shoeType)
        })
      }
      const fogge = filteredSoles.map(sole => {
        return sole.foggia
      })
      this.filteredSoles = [...filteredSoles]
      this.filteredFogge = Array.from(new Map(fogge.map(foggia => [foggia.id, foggia])).values())
    },

    setSole(sole) {
      this.mod.sole = sole
      this.$emit('update:mod', this.mod)
    },
  },
}
</script>
<style>
.opaque {
  opacity: 0.5;
}
</style>
